// Consultancy data — Kenneth Nathanael Lukman LLC
// A boutique property consultancy that curates and oversees premium serviced
// apartments across the UK on behalf of private owners, family offices and
// investors — combining design, operations and yield strategy into a single,
// calm mandate.

export const consultancyServices = [
  {
    id: "portfolio-blueprint",
    number: "01",
    tag: "Yield · Layout · Positioning",
    title: "The Landlord's Blueprint",
    subtitle: "A written positioning study, engineered for premium yield.",
    description:
      "We audit each of your assets and hand back a written blueprint covering layout, positioning, rate strategy, and compliance. Data-driven, benchmarked against live market performance in the same postcode, and structured so the recommendations can be actioned by whichever operator or letting agent you choose.",
    bullets: [
      "Micro-market yield model, benchmarked against live market data",
      "Layout & interior blueprint tuned for premium ADR and length-of-stay",
      "Rate, channel and positioning strategy per season",
      "Tenancy, licensing & Section 3C compliance review",
    ],
    price: "£3,000 – £6,000",
    priceNote: "flat · per property",
    image: "/consultancy/service-1.jpeg",
  },
  {
    id: "capital-works-governance",
    number: "02",
    tag: "Refurbishment · Fit-Out",
    title: "Capital Works Governance",
    subtitle: "Independent supervision of refurbishments and fit-outs.",
    description:
      "We source, brief, and audit trades on your behalf — with a single test: does every pound spent earn a pound of rent? You retain full control of capital; we oversee scope, quality, materials, and invoices at every milestone, then hand back an audited close-out pack.",
    bullets: [
      "Contractor sourcing, vetting & background checks",
      "On-site milestone, quality & materials audits",
      "Invoice verification, VO scrutiny & dispute handling",
      "Documented close-out & operational readiness sign-off",
    ],
    price: "10%",
    priceNote: "of the refurbishment contract value",
    image: "/consultancy/service-2.jpeg",
  },
  {
    id: "operator-search",
    number: "03",
    tag: "Operator Selection · Contract Oversight",
    title: "Operator Search & Oversight",
    subtitle: "Operator selection and quarterly performance oversight, always on the owner's side of the table.",
    description:
      "When an asset benefits from a specialist operator, letting agent, or property manager, we shortlist, benchmark, and negotiate on your behalf — then continue to review performance quarter by quarter. Every contract, fee, and revenue line remains between you and the appointed party, with our team reviewing the numbers on your side of the table.",
    bullets: [
      "Operator & agent shortlisting with performance benchmarks",
      "Contract, fee & revenue-share terms review",
      "Quarterly independent performance audit (ADR, RevPAR, NOI)",
      "Escalation & re-tendering support if targets are missed",
    ],
    price: "£1,500",
    priceNote: "per property · per quarter · retainer",
    image: "/consultancy/service-3.jpeg",
  },
];

export const consultancyProcess = [
  {
    number: "01",
    title: "Introductory Call",
    body: "A private, no-fee conversation to understand the asset, jurisdiction, and the outcome you're actually optimising for. Every conversation stays confidential.",
  },
  {
    number: "02",
    title: "Written Engagement",
    body: "A tailored mandate document with scope, deliverables, and yield assumptions per asset. Nothing begins until it is committed to paper.",
  },
  {
    number: "03",
    title: "Independent Advisory",
    body: "Our consulting bench delivers — blueprints, oversight, and operator search — while you retain full control of capital, contracts, and appointments.",
  },
  {
    number: "04",
    title: "Ongoing Review",
    body: "Monthly performance audits, occupancy & yield dashboards, and quarterly portfolio reviews so decisions compound rather than repeat.",
  },
];

export const consultancyPillars = [
  {
    title: "One calm mandate",
    body: "Design, operations and yield strategy folded into a single written mandate — never the fragmented vendor stack most owners inherit.",
  },
  {
    title: "One-sided fees",
    body: "You are the only party we invoice. No brokerage splits, no operator kickbacks, no hidden margins.",
  },
  {
    title: "Never custody your capital",
    body: "Rent, deposits, and refurb payments flow through your accounts, never ours. Independence is a structure, not a promise.",
  },
  {
    title: "Data, not gut",
    body: "Every blueprint is grounded in live ADR, RevPAR, and stay-length data from the exact micro-market you own in.",
  },
];
